import sheetTwoPage from '@/pages/sheetPage/SheetTwo';

export default {
    path: '/arkusz2/:familyId',
    props: true,
    name: 'sheet-two',
    component: sheetTwoPage,
    meta: { requiresAuth: true }
};
